import Footer from "./Footer";
import Header from "./Header";

const Disclaimer = () => {
  return (
    <>
      <Header />

      <section className="bg-white py-5">
        <div className="container">
          <h1 className="display-6 text-dark">Disclaimer</h1>

          <section>
            <h3 className="text-dark">1. General Information</h3>
            <p>
              The content provided on <u>Visualaey</u> is for general
              informational purposes only. While we strive to ensure accuracy,
              Visualaey makes no representations or warranties of any kind,
              express or implied, about the completeness, accuracy, reliability,
              or availability of the information, products, or services offered
              on the platform.
            </p>
          </section>

          <section>
            <h3 className="text-dark">2. No Professional Advice</h3>
            <p>
              The materials and information on Visualaey are not intended as
              professional advice. Users should not rely on any content as a
              substitute for professional guidance in areas such as photography,
              event management, security, or technology.
            </p>
          </section>

          <section>
            <h3 className="text-dark">3. Use at Your Own Risk</h3>
            <p>
              By using Visualaey, you acknowledge that any reliance on the
              platform’s content or services is at your own risk. Visualaey is
              not liable for any loss, damage, or inconvenience arising from the
              use of our services or any content provided.
            </p>
          </section>

          <section>
            <h3 className="text-dark">4. Third-Party Links and Services</h3>
            <p>
              Visualaey may contain links to third-party websites or services,
              including Razorpay for payment processing. We do not control these
              third parties and are not responsible for their content, privacy
              practices, or any transactions carried out on their platforms.
            </p>
          </section>

          <section>
            <h3 className="text-dark">5. Limitation of Liability</h3>
            <p>
              To the maximum extent permitted by law, Visualaey, its affiliates,
              and partners disclaim all liability for any direct, indirect,
              incidental, consequential, or punitive damages arising from the
              use of the platform, including but not limited to errors,
              omissions, interruptions, or inaccuracies.
            </p>
          </section>

          <section>
            <h3 className="text-dark">6. No Warranty</h3>
            <p>
              Visualaey provides its services "as is" and "as available" without
              any warranty of any kind, either express or implied, including
              warranties of merchantability, fitness for a particular purpose,
              or non-infringement.
            </p>
          </section>

          <section>
            <h3 className="text-dark">7. Changes to Disclaimer</h3>
            <p>
              Visualaey reserves the right to update this Disclaimer at any
              time. Users are encouraged to review this page periodically.
              Continued use of the platform constitutes acceptance of any
              updates or changes to this Disclaimer.
            </p>
          </section>

          <section>
            <h3 className="text-dark">8. Contact Us</h3>
            <p>
              If you have any questions about this Disclaimer, please contact
              our support team at{" "}
              <a href="mailto:support@visualaey.com">support@visualaey.com</a>.
            </p>
          </section>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Disclaimer;
